import axios from "axios";
import { getAdminAuth } from "../store/menupro.admin.store";

const API = "https://mototaksi.az:9999/api/menupro";

/* ===== AUTH ===== */
export const register = (data) => axios.post(`${API}/business/register`, data);
export const login = (data) => axios.post(`${API}/business/login`, data);

export const sendOtp = (phone) =>
  axios.get(`${API}/otp/send`, { params: { phone } });

export const verifyOtp = (phone, code) =>
  axios.get(`${API}/otp/verify`, { params: { phone, code } });

/* ===== BUSINESS PROFILE ===== */
export const getProfile = (id) => axios.get(`${API}/business/profile/${id}`);
export const updateProfile = (id, data) =>
  axios.put(`${API}/business/profile/${id}`, data);

/* ===== CATEGORIES ===== */
export const getCategories = (businessId) => axios.get(`${API}/category/${businessId}`);
export const createCategory = (businessId, data) => axios.post(`${API}/category/${businessId}`, data);
export const deleteCategory = (categoryId) => axios.delete(`${API}/category/${categoryId}`);

/* ===== PRODUCTS ===== */
export const getProducts = (businessId) => axios.get(`${API}/product/${businessId}`);
export const createProduct = (businessId, data) => axios.post(`${API}/product/${businessId}`, data);
export const deleteProduct = (id) => axios.delete(`${API}/product/${id}`);
export const updateProduct = (id, data) => axios.put(`${API}/product/${id}`, data);

export const getProductById = async (businessId, id) => {
  const res = await getProducts(businessId);
  return res.data.find((p) => String(p.id) === String(id));
};

/* ===== PUBLIC MENU ===== */
export const publicMenu = (slug) => axios.get(`${API}/public/${slug}`);
export const publicProfile = (slug) => axios.get(`${API}/public/profile/${slug}`);

/* ===== APPROVAL STATUS (WAITING) ===== */
export const approvalByPhone = (phone) =>
  axios.get(`${API}/public/approval-by-phone`, { params: { phone } });

/* ===== ADMIN ===== */
const adminHeaders = () => {
  const a = getAdminAuth();
  return a ? { "X-ADMIN-USER": a.u, "X-ADMIN-PASS": a.p } : {};
};

export const getPendingBusinesses = () =>
  axios.get(`${API}/admin/business/pending`, { headers: adminHeaders() });

export const approveBusiness = (id) =>
  axios.post(`${API}/admin/business/${id}/approve`, null, { headers: adminHeaders() });

export const rejectBusiness = (id, reason) =>
  axios.post(`${API}/admin/business/${id}/reject`, null, {
    params: { reason },
    headers: adminHeaders(),
  });

export const testAdminAuth = (u, p) =>
  axios.get(`${API}/admin/business/pending`, {
    headers: {
      "X-ADMIN-USER": u,
      "X-ADMIN-PASS": p,
    },
  });
